export const SUBCONTRACTED_FILTERS = (currentUser) => {
	return {
		selector: 'assigned',
		items: [
			{
				selectVal: undefined,
				label: 'All',
				value: {
					isSubContracted: undefined,
				},
			},
			{
				selectVal: 'selfPerforming',
				label: 'Self Performing',
				value: {
					isSubContracted: 'false',
				},
			},
			{
				selectVal: 'subContracted',
				label: 'Subcontracted',
				value: {
					isSubContracted: 'true',
				},
			},
		],
	};
};
